import type { StatePack } from './types'

/**
 * New York pilot state pack.
 *
 * Top scam ordering follows the FBI IC3 2023 state report for New York
 * (investment fraud and BEC top reported losses). Numbers are placeholders
 * until we drop in the IC3 2024 release as the canonical source.
 */
export const ny: StatePack = {
  slug: 'ny',
  name: 'New York',
  sponsor: {
    label: 'Presented by the State of New York',
  },
  topScams: [
    {
      id: 'investment-fraud',
      name: 'Investment Fraud',
      blurb:
        'New Yorkers reported the highest losses to investment scams last year, especially "pig butchering" crypto schemes that start with a friendly text or DM.',
      lossUsd: 1_100_000_000,
    },
    {
      id: 'business-email-compromise',
      name: 'Business Email Compromise',
      blurb:
        'Scammers impersonate executives, vendors, or attorneys to redirect wire transfers. New York leads the nation in BEC losses.',
      lossUsd: 460_000_000,
    },
    {
      id: 'tech-support',
      name: 'Tech Support Scams',
      blurb:
        'Pop-ups and phone calls claim your computer is infected. The "fix" drains your bank account.',
      lossUsd: 95_000_000,
    },
    {
      id: 'romance-scams',
      name: 'Romance Scams',
      blurb:
        'A months-long online relationship that ends in an urgent request for money. Often connected to investment fraud.',
      lossUsd: 80_000_000,
    },
  ],
  agencies: [
    {
      name: 'New York Attorney General, Consumer Frauds Bureau',
      description: 'File a complaint about a scam targeting New York residents.',
      url: 'https://ag.ny.gov/consumer-frauds',
      phone: '1-800-771-7755',
    },
    {
      name: 'NY Department of Financial Services',
      description: 'Report investment, banking, or insurance fraud.',
      url: 'https://www.dfs.ny.gov',
      phone: '1-800-342-3736',
    },
    {
      name: 'IC3 (FBI Internet Crime Complaint Center)',
      description: 'Report internet-enabled crime and fraud.',
      url: 'https://www.ic3.gov',
    },
    {
      name: 'AARP New York Fraud Watch Helpline',
      description: 'Talk to a trained fraud specialist.',
      phone: '1-877-908-3360',
    },
  ],
  exampleOverrides: {
    // Example: chapter 3 (Pause and Verify) "call the bank" interactive can use
    // a NY-specific bank for added realism. Slide components opt in.
    'pv-call-bank': {
      bankName: 'Chase',
      bankPhone: '1-800-432-3117',
    },
    // Investment fraud framing for the chapter 4 warning-signs interactive.
    'ws-pig-butchering': {
      cityName: 'Manhattan',
      platformName: 'a popular dating app',
    },
  },
}
